import React from 'react';

export const UserPlusIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 18 18"
        width={18}
        height={18}
        {...props}
    >
        <path
            d="M8.467 12.733a4.267 4.267 0 108.533 0 4.267 4.267 0 00-8.533 0zM12.733 10.6v4.267M10.6 12.733h4.267M1 12.733A4.802 4.802 0 017.684 8.32M2.867 3.933a2.933 2.933 0 105.866 0 2.933 2.933 0 00-5.866 0v0z"
            stroke="currentColor"
        />
    </svg>
);
